import { useState } from 'react';

import PropTypes from 'prop-types';
import { BsSlashCircle } from 'react-icons/bs';

import Modal from '#globalComponents/Overlay/Modal';
import Panel from '#globalComponents/Overlay/Panel';

import { useCampaignBlockedRecipients } from '../../models/emailSends/queries';

import BlockedRecipientsTable from './BlockedRecipientsTable';

const BlockedRecipientsHint = ({ campaignId, blockedCount }) => {
	const [isOpen, setIsOpen] = useState(false);
	const { data, isLoading } = useCampaignBlockedRecipients(campaignId, { enabled: isOpen });

	if (!blockedCount) return null;

	return (
		<>
			<p className="flex items-center gap-1.5 text-sm text-bgBase-800">
				<BsSlashCircle className="h-4 w-4" />
				{blockedCount.toLocaleString('de-DE')} Empfänger blockiert –
				<button
					type="button"
					onClick={() => setIsOpen(true)}
					className="text-primary-600 underline hover:text-primary-700"
				>
					anzeigen
				</button>
			</p>
			<Modal isOpen={isOpen} onClose={() => setIsOpen(false)} size="l">
				<Panel.Header onClose={() => setIsOpen(false)}>Blockierte Empfänger</Panel.Header>
				<Panel.Body>
					<BlockedRecipientsTable recipients={data?.blockedRecipients ?? []} isLoading={isLoading} />
				</Panel.Body>
			</Modal>
		</>
	);
};

BlockedRecipientsHint.propTypes = {
	campaignId: PropTypes.string.isRequired,
	blockedCount: PropTypes.number,
};

export default BlockedRecipientsHint;
